import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const FOOTER_COLS = [
  { title: "Businesses", links: [["KRVMart", "https://www.krvmart.com"], ["KRV FinMart", "https://www.krvfinmart.com"]] },
  { title: "KRVMart", links: [["Home Mart", "#businesses"], ["Style Mart", "#businesses"], ["Wood Mart", "#businesses"], ["Tech Mart", "#businesses"]] },
  { title: "KRV FinMart", links: [["Education", "#businesses"], ["Research", "#businesses"], ["Market Insights", "#contact"]] },
  { title: "Company", links: [["About", "#about"], ["Vision", "#vision"], ["Careers", "#careers"], ["Contact", "#contact"]] },
  { title: "Legal", links: [["Privacy Policy", "/legal/privacy"], ["Terms", "/legal/terms"], ["Disclaimer", "/legal/disclaimer"], ["Cookie Policy", "/legal/cookies"]] },
];

const FooterLink = ({ label, href }) => {
  const testId = `footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`;
  const cls = "text-sm text-ivory/60 hover:text-ivory transition-colors";
  if (href.startsWith("/")) return <Link to={href} className={cls} data-testid={testId}>{label}</Link>;
  return <a href={href} className={cls} data-testid={testId}>{label}</a>;
};

export const FinalMessage = () => (
  <section data-testid="final-message" className="bg-ivory text-navy py-28 lg:py-40 text-center">
    <div className="max-w-4xl mx-auto px-6">
      <Reveal>
        <p className="font-serif text-2xl text-gold-deep mb-4">KRV Nexus</p>
        <h2 className="font-serif font-light text-5xl sm:text-7xl lg:text-8xl tracking-tighter leading-[0.95]">
          Where Vision<br />Becomes Value.
        </h2>
        <p className="mt-8 text-lg text-navy/60">Building businesses. Connecting possibilities. Creating enduring value.</p>
        <a href="#businesses" data-testid="final-cta" className="mt-10 inline-flex items-center gap-2 bg-navy text-ivory px-8 py-4 rounded-full font-medium hover:bg-charcoal transition-colors group">
          Explore Our Businesses
          <ArrowUpRight size={18} className="text-gold group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
        </a>
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy text-ivory border-t border-white/10 noise-overlay">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 lg:py-20">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-2">
            <span className="font-serif text-3xl text-ivory">KRV</span>
            <span className="font-serif text-3xl text-gold">Nexus</span>
          </div>
          <p className="mt-4 text-ivory/50 max-w-xs">Where Vision Becomes Value.</p>
        </div>

        <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {FOOTER_COLS.map((col) => (
            <div key={col.title}>
              <p className="text-xs uppercase tracking-[0.2em] text-gold mb-4">{col.title}</p>
              <ul className="space-y-2.5">
                {col.links.map(([label, href]) => (
                  <li key={label}><FooterLink label={label} href={href} /></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-ivory/40">
        <p>© 2026 KRV Nexus Pvt Ltd. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <Link to="/admin/login" className="hover:text-gold transition-colors" data-testid="footer-admin-link">Admin</Link>
          <p>Emerging multi-business organization · India</p>
        </div>
      </div>
    </div>
  </footer>
);
